import { ShopOutlined } from "@ant-design/icons";
import { Modal, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { RootState } from "app.store";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setProductStockModal } from "states/global-value/global-value.slice";
import { InventoryModel } from "states/product/product.models";

export function ProductStockModal() {
  const dispatch = useDispatch();
  const productStockModal = useSelector(
    (state: RootState) => state.globalValue.productStockModal,
    shallowEqual
  );

  const columns: ColumnsType<InventoryModel> = [
    {
      title: "Kho hàng",
      dataIndex: "wareHouse",
      key: "wareHouse",
      render: (wareHouse: string, item) => (
        <>
          <ShopOutlined /> {item.wareHouse.name}
        </>
      ),
    },
    {
      title: "Tồn kho",
      dataIndex: "stock",
      key: "stock",
      render: (stock: string, item) => <>{item.totalStockQuantity}</>,
    },
    {
      title: "Thực tế",
      dataIndex: "stock",
      key: "stock",
      render: (stock: string, item) => <>{item.onHandQuantity}</>,
    },
    {
      title: "Có thể bán",
      dataIndex: "ordered",
      key: "ordered",
      render: (ordered: string, item) => <>{item.totalReadyForSaleQuantity}</>,
    },
    {
      title: "Hàng sắp về",
      dataIndex: "upcoming",
      key: "upcoming",
      render: (upcoming: string, item) => <>{item.upComingQuantity}</>,
    },
  ];

  return (
    <Modal
      title="Danh sách tồn kho"
      cancelText="Đóng"
      okText="Ok"
      onOk={() => {
        dispatch(setProductStockModal({ ...productStockModal, show: false }));
      }}
      visible={productStockModal.show}
      onCancel={() => {
        dispatch(setProductStockModal({ ...productStockModal, show: false }));
      }}
      width={800}
    >
      <Table
        columns={columns}
        dataSource={productStockModal.productStocks}
        size="small"
        pagination={false}
      ></Table>
    </Modal>
  );
}
